import React, { Component } from 'react';
import { connect } from 'react-redux';

class Footer extends Component {
	render() {
		return (
			<footer className="navbar mt-auto text-center px-0">
				<h1 className="sr-only visually-hidden">Assist@: Footer</h1>
				<div className="container-fluid container-hd px-sm">
					<h2 className="fs-3 mr-2">© 2024 Assist@. All rights reserved.</h2>
					<nav className="nav align-items-center ml-md-auto fs-3">
						<h1 className="sr-only visually-hidden">Footer: navigation</h1>
						{/* <a className="nav-link o-60 o-100--hover" target="blank" href="mailto:contact@assistarobase.fr">Contact</a> */}
					</nav>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
